import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { flagPortrait } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { formatPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

const ProctorDetails = observer(class ProctorDetails extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.proctorTypeDisplayName = this.proctorTypeDisplayName.bind(this);
  }

  componentWillMount() {
    const { LocationStore, ProctorStore } = this.props.store;
    const { proctorAccountSid } = this.props;

    this.state = {
      proctorTypes: []
    }

    ProctorStore.getProctor(proctorAccountSid, null, this.proctorTypeDisplayName);
    LocationStore.getLocations(proctorAccountSid);
  }

  proctorTypeDisplayName(proctor) {
    const { proctorTypeList } = this.props.store.SessionStore;

    let proctorTypes = [...this.state.proctorTypes];

    if(proctor.proctorTypes.length > 0) {
      proctor.proctorTypes.forEach(proctorTypeSid => {
        proctorTypeList.forEach(parentType => {
          parentType.subCategories.forEach(proctorType => {
            if(proctorTypeSid === proctorType.sid) {
              proctorTypes.push(proctorType.title);
            }
          });
        });
      })
    }

    this.setState({
      proctorTypes
    });
  }

  render() {
    const { translation } = this.props;
    const { LocationStore, ProctorStore, SessionStore } = this.props.store;
    const { proctor } = ProctorStore;

    if(!SessionStore.loading) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <div className="wrap">
            <div className="panel--medium">
              <figure className="media--alt media--alt-top">
                {proctor.image && proctor.image !== 'https://s3.amazonaws.com/' &&
                  <span className="proctor__avatar avatar-wrap">
                    <img
                      className="avatar"
                      src={proctor.image}
                      alt=""
                      onLoad={(e) => flagPortrait(e, proctor.image)}
                    />
                  </span>
                }

                {(!proctor.image || proctor.image === 'https://s3.amazonaws.com/') &&
                  <span className="proctor__avatar avatar-wrap">
                    <img
                      className="avatar avatar--missing"
                      src="./static/img/avatar-default.png"
                      alt="No avatar provided"
                      onLoad={(e) => flagPortrait(e, './static/img/avatar-default.png')}
                    />
                  </span>
                }

                <figcaption className="media__copy">
                  <h3 className="proctor__title fn org">
                    {proctor.accountName}
                  </h3>

                  <ul className="simple-list">
                    {proctor.email &&
                      <li>
                        <a href={`mailto:${proctor.email}`}>
                          {proctor.email}
                        </a>
                      </li>
                    }

                    {proctor.phoneNumber &&
                      <li>
                        {
                          formatPhoneNumber(
                            proctor.phoneNumber,
                            parsePhoneNumber(proctor.phoneNumber).country,
                            'National'
                          )
                        }
                      </li>
                    }

                    <li>
                      {this.state.proctorTypes.length > 0 &&
                        <ul className="data--comma">
                          {this.state.proctorTypes.map(
                            (proctorType, i) =>
                            <li key={i}>{proctorType}</li>
                          )}
                        </ul>
                      }
                    </li>
                  </ul>
                </figcaption>
              </figure>

              {LocationStore.locations.length > 0 &&
                <div className="approval__details">
                  <section className="approval__details-section">
                    <h4>Locations</h4>

                    <ul className="simple-list">
                      {LocationStore.locations.map((location, i) =>
                        <li key={i} className="adr">
                          <strong>{location.name}</strong>

                          <span className="street-address">
                            {location.address1} {location.address2}
                          </span>

                          {location.place &&
                            <span className="locality">{location.place}, </span>
                          }
                          <span className="region">{location.region} </span>
                          <span className="postal-code">{location.postalCode}</span>
                        </li>
                      )}
                    </ul>
                  </section>
                </div>
              }
            </div>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('ProctorDetails')(ProctorDetails);



// WEBPACK FOOTER //
// ./src/app/components/Drawer/ProctorDetails.js